import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CurrencyExchangeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CurrencyExchangeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.2258 10.1132H14.1126C14.4599 10.1132 14.7415 9.83164 14.7415 9.4843C14.7415 9.13696 14.4599 8.85538 14.1126 8.85538H13.1692C13.1692 8.50804 12.8876 8.22646 12.5403 8.22646C12.1929 8.22646 11.9114 8.50804 11.9114 8.85538V8.88368C10.8849 9.06339 10.1985 10.0411 10.3782 11.0676C10.5356 11.9663 11.3135 12.6236 12.2258 12.6289H12.8547C13.2021 12.6289 13.4837 12.9105 13.4837 13.2578C13.4837 13.6052 13.2021 13.8867 12.8547 13.8867H10.968C10.6206 13.8867 10.3391 14.1683 10.3391 14.5157C10.3391 14.863 10.6206 15.1446 10.968 15.1446H11.9114C11.9114 15.4919 12.1929 15.7735 12.5403 15.7735C12.8876 15.7735 13.1692 15.4919 13.1692 15.1446V15.1163C14.1956 14.9366 14.882 13.9588 14.7023 12.9324C14.545 12.0337 13.7671 11.3763 12.8547 11.3711H12.2258C11.8785 11.3711 11.5969 11.0895 11.5969 10.7421C11.5969 10.3948 11.8785 10.1132 12.2258 10.1132Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5403 5.71077C9.06683 5.71077 6.25106 8.52655 6.25106 12C6.25106 15.4734 9.06684 18.2892 12.5403 18.2892C16.0137 18.2892 18.8295 15.4734 18.8295 12C18.8295 8.52655 16.0137 5.71077 12.5403 5.71077ZM12.5403 17.0314C9.76152 17.0314 7.5089 14.7787 7.5089 12C7.5089 9.22124 9.76152 6.96862 12.5403 6.96862C15.319 6.96862 17.5716 9.22124 17.5716 12C17.5716 14.7787 15.319 17.0314 12.5403 17.0314Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5403 3.824C16.0174 3.82927 19.1124 6.02914 20.2603 9.31134L19.3169 9.45914L21.3452 12L22.5244 8.95915L21.515 9.11638C20.2628 5.21602 16.6367 2.56946 12.5403 2.56616C12.1929 2.56616 11.9114 2.84774 11.9114 3.19508C11.9114 3.54242 12.1929 3.824 12.5403 3.824Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5403 20.176C9.06313 20.1707 5.96818 17.9708 4.82026 14.6886L5.77937 14.5408L3.73538 12L2.55615 15.0408L3.56557 14.8836C4.81771 18.7839 8.44386 21.4305 12.5403 21.4338C12.8876 21.4338 13.1692 21.1522 13.1692 20.8049C13.1692 20.4575 12.8876 20.176 12.5403 20.176Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.32967 6.41516C6.49575 6.41529 6.65514 6.34973 6.77306 6.23277C7.01967 5.98817 7.02131 5.58996 6.77671 5.34335C6.53211 5.09674 6.1339 5.0951 5.88729 5.3397C5.64068 5.5843 5.63904 5.98251 5.88364 6.22912C6.00161 6.34806 6.16215 6.41503 6.32967 6.41516Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M3.81713 10.7421C4.15685 10.8145 4.49092 10.5978 4.56329 10.2581C4.63566 9.91834 4.41893 9.58427 4.07921 9.5119C3.73949 9.43953 3.40542 9.65626 3.33305 9.99598C3.33299 9.99627 3.33311 9.99569 3.33305 9.99598C3.26124 10.3355 3.47775 10.6699 3.81713 10.7421Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.52152 8.3428C4.61767 8.39603 4.72609 8.42314 4.83598 8.42142C5.18321 8.43032 5.47191 8.15606 5.48082 7.80883C5.4869 7.57181 5.35917 7.35152 5.15044 7.23905C4.84565 7.06538 4.45777 7.17167 4.2841 7.47647C4.11043 7.78126 4.21672 8.16913 4.52152 8.3428Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.3326 17.7955C18.0872 18.0412 18.0874 18.4395 18.3331 18.6849C18.5789 18.9304 18.9771 18.9302 19.2226 18.6844C19.4679 18.4389 19.4679 18.041 19.2226 17.7955C18.9771 17.5497 18.5784 17.55 18.3326 17.7955Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.5842 15.6855C20.2794 15.5187 19.8971 15.6307 19.7304 15.9355C19.5637 16.2403 19.6756 16.6225 19.9804 16.7892C20.0774 16.8401 20.1854 16.866 20.2949 16.8647C20.5227 16.8679 20.7344 16.7476 20.8483 16.5502C21.0166 16.2464 20.9067 15.8636 20.6028 15.6954C20.5966 15.692 20.5904 15.6887 20.5842 15.6855Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2917 13.2736C20.9487 13.2015 20.6122 13.4211 20.5402 13.7641C20.4681 14.1071 20.6877 14.4436 21.0307 14.5157C21.0757 14.5203 21.121 14.5203 21.1659 14.5157C21.4667 14.5227 21.7303 14.3158 21.7949 14.022C21.8664 13.6821 21.6489 13.3485 21.309 13.277C21.3033 13.2757 21.2975 13.2746 21.2917 13.2736Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CurrencyExchangeIcon;
